<ui-text-form-field
	[title]="showFieldNames() ? 'E-mail' : undefined"
	[isRequired]="true"
	[validation]="'email'"
	[placeholder]="'E-mail'"
	[valueAsSignal]="form.email"
	[maxLength]="50"
></ui-text-form-field>

<ui-password-form-field
	class="push-top-md"
	[title]="showFieldNames() ? 'Password' : undefined"
	[isRequired]="true"
	[enablePasswordPreview]="enablePasswordPreview()"
	[valueAsSignal]="form.password"
></ui-password-form-field>

<ui-form-save-button
	[title]="'Sign up'"
	[saveHandler]="saveHandler()"
	[useFullSize]="useFullSize()"
	[enableEnterSaveShortcut]="true"
	[logHandler]="formLogHandler()"
></ui-form-save-button>
